import { Typography } from '@breetometer/components';
import { AnimatedRefreshIcon, InfoIcon } from 'BreetAssets';
import { Tooltip, TooltipContent } from 'BreetComponents';

import type { IPageHeader } from './PageHeader.helpers';

export const PageHeader = ({ pageTitle, isLoading, onRefresh, tip, counter }: IPageHeader) => (
	<div className='pageHeader'>
		<div className='pageHeader-title'>
			<Typography
				as='h1'
				className='color-neutral-50'
			>
				{pageTitle}
			</Typography>

			{!!counter && (
				<Typography
					as='span'
					className='counter-txt'
				>
					{counter.toLocaleString()}
				</Typography>
			)}
		</div>

		<div className='hidden'>
			{tip && (
				<Tooltip tipElement={<TooltipContent content={tip} />}>
					<InfoIcon
						variant='square-dark'
						className='svg-dark'
					/>
				</Tooltip>
			)}
		</div>

		{onRefresh ? (
			<AnimatedRefreshIcon
				className='cursor_pointer svg-dark svg-dark-outline svg-dark-fill'
				variant={isLoading ? 'spin' : 'static'}
				focusable
				onClick={onRefresh}
				aria-label='refresh icon'
			/>
		) : (
			isLoading && <div className='button-spinner' />
		)}
	</div>
);
